const INITIAL_STATE = {
  data: {},
  errors: {},

}
const getPaymentHistory = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_PAYMENT_HISTORY_SUCCESSFULLY':
    return { ...state, data: action.data }
  case 'GET_PAYMENT_HISTORY_FAILED':
    return { ...state, errors: action.data }
  default:
    return { ...state }
  }
};

export default getPaymentHistory;